import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
declare var System: any;

// declare let ClientIP: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  ipAddress:string;  
  privateIP;
  ClientIP: string[] = new Array<string>();

  constructor(private http:HttpClient) {
    //this.getIP();
    this.privateIP = document.getElementById('ip').innerHTML;
    this.ClientIP = this.privateIP.split(':');
    if (this.ClientIP.length > 1) {
      localStorage.setItem('privateIP', (this.ClientIP[1]).trim());
    }
  }

  ngOnInit()  
  {   
    System.import('public-ip').then(data => {
      data.v4().then(ip => {
      localStorage.setItem('privateIP',ip);
      });
      });
  }  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts